import { StrictMode } from 'react';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { hydrate, render } from 'react-dom';
import Entry from './Entry';

import './index.css';

const rootElement = document.getElementById('root');
if (rootElement.hasChildNodes()) {
    hydrate(<StrictMode>
        <Entry />
    </StrictMode>, rootElement);
}
else {
    render(<StrictMode>
        <Entry />
    </StrictMode>, rootElement);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
